<div class="component-field-textarea-condensed show">
	<label class="field-textarea">
		<section class="txtarea-section-body">
			<p class="txtarea-label">{{ labelValue }}</p>
			@if (valueToReturn && valueToReturn.length > 1000) {
				<div class="txtarea-input">
					{{ valueToReturn | slice: 0 : 1000 }}
					@if (valueToReturn.length > 1000) {
						<a class="text-xs text-primary ml-[10px]" (click)="openModal()">Ver mais</a>
					}
				</div>
			}
			@if (valueToReturn && valueToReturn.length <= 1000) {
				<div class="txtarea-input">
					{{ valueToReturn }}
				</div>
			}
		</section>
		<section
			title="Copiar!"
			(click)="copyToClipboard($event)"
			class="txtarea-section-icon cursor-pointer"
		>
			<div class="txtarea-icon-copy"></div>
		</section>
	</label>
</div>

<ng-template #textAreaSupport>
	<section class="inline-flex w-full mb-[40px]">
		<div
			class="svg-icon-arrow w-6 h-[24px] bg-primary mt-[15px] mr-[15px]"
			(click)="closeModal()"
		></div>
		<div class="flex flex-col">
			<div
				class="text-center -ml-[5px] justify-center flex items-center text-xl w-[51px] h-[51px] rounded-full bg-gray-200 border-gray-600 text-gray-600 border border-solid"
			>
				{{ getInicials(lane.user) }}
			</div>
		</div>
		<div class="flex flex-col mt-[10px]">
			<div class="text-base text-primary ml-[25px]">{{ lane.user }}</div>
			<div class="text-xs text-gray-600 ml-[25px]">{{ dataPrazo }}</div>
		</div>
	</section>

	<section class="form-fields-sub-module-modal">
		<div class="ff-row-form overflow-x-hidden">
			<div class="ff-box-field ff-field-size-7">
				{{ valueToReturn }}
			</div>
		</div>
	</section>

	<section class="flex mt-[40px] absolute bottom-30">
		<button type="button" class="btn-primary btn-type-2 ml-[4px]" (click)="closeModal()">
			Fechar
		</button>
	</section>
</ng-template>

<ng-template #templateCopy>
	<div class="text-base text-font flex items-center justify-center show">
		Copiado!
		<div class="emojis-happy icon-box ml-[16px]"></div>
	</div>
</ng-template>
